import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <Box
      component="main"
      sx={{
        minHeight: "100dvh",
        display: "grid",
        bgcolor: "background.default",
      }}
    >
      <Outlet />
    </Box>
  );
}
